import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-download-spinner"
export default class extends Controller {
  connect() {
    this.element.addEventListener('submit', this.handleFormSubmit.bind(this))
  }

  handleFormSubmit(e) {
    const submitButton = e.submitter

    if (submitButton && submitButton.name === 'download_excel') {
      document.dispatchEvent(new CustomEvent('spinner:show'))

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent('spinner:hide'))

        const submitButtons = this.element.querySelectorAll('button[type="submit"], input[type="submit"]')
        submitButtons.forEach(btn => {
          btn.disabled = false
        })
      }, 1500)
    }
  }

  disconnect() {
    this.element.removeEventListener('submit', this.handleFormSubmit.bind(this))
  }
}


